/* @flow */
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import * as React from 'react';
import QuickPromotion from 'entities/QuickPromotion';
import CurrentUser from 'auth/CurrentUser';
import ClassNavigationPromotion from 'groups/components/ClassNavigationPromotion';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { TriggerTypes, ResponseTypes } from 'constants/QuickPromotionConstants';
import QuickPromotionActions from 'actions/QuickPromotionActions';

type State = {
  promotion: ?QuickPromotion,
};

class ClassNavigationPromotionContainer extends React.Component<{}, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static getStores() {
    return [CurrentUser];
  }

  static calculateState(): State {
    return {
      promotion: CurrentUser.getQuickPromotionsForTrigger(TriggerTypes.CLASSES_LIST_TOP).find(p =>
        p.isShowable()
      ),
    };
  }

  onConfirm = () => {
    const { promotion } = this.state;
    if (promotion) {
      handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION);
    }
  };
  onCancel = () => {
    const { promotion } = this.state;
    if (promotion) {
      QuickPromotionActions.recordDismissal(promotion, ResponseTypes.SECONDARY_ACTION);
    }
  };
  render() {
    const { promotion } = this.state;
    return promotion ? (
      <ClassNavigationPromotion
        promotion={promotion}
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
      />
    ) : null;
  }
}

export default Container.create(ClassNavigationPromotionContainer);
